import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export type PeriodMonths = 3 | 6 | 12;

interface PeriodFilterProps {
  value: PeriodMonths;
  onChange: (v: PeriodMonths) => void;
}

export default function PeriodFilter({ value, onChange }: PeriodFilterProps) {
  return (
    <ToggleGroup
      type="single"
      value={String(value)}
      onValueChange={(v) => v && onChange(Number(v) as PeriodMonths)}
      className="bg-secondary rounded-lg p-1"
    >
      {[3, 6, 12].map((m) => (
        <ToggleGroupItem
          key={m}
          value={String(m)}
          className="text-xs px-3 py-1 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground rounded-md"
        >
          {m} meses
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
